import React from 'react';
import { Route } from 'react-router-dom';

const NotLogged = () => {
    console.log('NotLogged => So redirect to ', process.env.REACT_APP_IDENTIDADE_URL_AUTHORIZE);
    window.location.href = process.env.REACT_APP_IDENTIDADE_URL_AUTHORIZE;
    return null;
};

export const PrivateRouter = ({ component: Component, isAuthenticated, ...rest }) => {
    return <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <NotLogged />)} />;
};

// export const PrivateRouter = ({ component: Component, isAuthenticated, ...rest }) => {
//     return <Route {...rest} render={props => <Component {...props} />} />;
// };

export default PrivateRouter;
